// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eC15c","name":"Header_name__5eusL","birthday":"Header_birthday__3Slyt","skeleton":"Header_skeleton__37Lwj"};